import { getCurrentInstance, onBeforeUnmount, onMounted, nextTick } from "vue";

export default function useFilterHistory() {
    const { emit } = getCurrentInstance();

    // never use in another composable
    onMounted(() => window.addEventListener("popstate", handlePopState));
    onBeforeUnmount(() =>
        window.removeEventListener("popstate", handlePopState)
    );

    function setFilter(filter) {
        emit("update:modelValue", filter);
        window.history.pushState({ filter: filter }, filter, "");
        nextTick(() => {
            // scroll the inner container used by LeftAsideSubLayout if present
            const layoutContainer = document.querySelector(
                '.sticky.top-\\[var\\(--app-header-height\\)\\] .overflow-x-auto'
            );
            if (layoutContainer) {
                layoutContainer.scrollTop = 0;
            }
        });
    }

    function handlePopState(event) {
        const filter = event.state?.filter;
        if (filter) {
            emit("update:modelValue", filter);
        }
    }

    return {
        setFilter,
    };
}
